import { render, staticRenderFns } from "./FlashExchange.vue?vue&type=template&id=1cf33cb9&scoped=true"
import script from "./FlashExchange.vue?vue&type=script&lang=js"
export * from "./FlashExchange.vue?vue&type=script&lang=js"
import style0 from "./FlashExchange.vue?vue&type=style&index=0&id=1cf33cb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf33cb9",
  null
  
)

export default component.exports